import styled from "styled-components";
import { device } from "../../services/styles";

export const Video = styled.video`
  width: auto;
  max-width: 100%;
  margin-bottom: 20px;
`;

export const VideoHeader = styled.p`
  margin: 20px 0 10px 0;
  font-size: 18px;
  font-weight: 900;
`;

export const BoxContaiener = styled.div`
  max-width: 300px;
  float: right;
  margin-left: 20px;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
`;

export const LeftBoxContaiener = styled.div`
  width: 100%;
  @media ${device.tablet} {
    width: 400px;
    float: left;
    margin-right: 20px;
    &:after {
      content: "";
      display: block;
      clear: both;
    }
  }
`;
